import { sortAsc } from '@strata/helper-functions';
import { GridWithSearch, PrimaryData, SecondaryData } from '@strata/react-grid';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

export const ParentProductServiceList = () => {
    const navigate = useNavigate();

    const parentProducts = useGet('/reference/parent_product_services');

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Parent Products"
                buttons={[
                    {
                        label: 'Create Parent Product',
                        path: `/parent-products/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={parentProducts}
                    isLoading={!parentProducts}
                    columns={[
                        {
                            accessorKey: 'display_name',
                            header: 'Parent Product',
                            size: 20,
                            cell: ({ getValue }) => <PrimaryData data={getValue()} />,
                        },
                        {
                            accessorKey: 'oids',
                            header: 'Product Oids',
                            size: 120,
                            cell: ({ getValue }) => (
                                <SecondaryData data={getValue().sort(sortAsc).join(', ')} />
                            ),
                        },
                    ]}
                    sortProperties={[{ id: 'display_name', desc: false }]}
                    onRowClick={(row) => navigate(`/parent-products/${row.parent_product_service}`)}
                />
            </div>
        </div>
    );
};
